import type { AxiosResponse } from 'axios'

import type { ApiClient } from 'clients/yogi-api'
import type { SavedView, SavedViewPayload } from 'features/saved-views/types'

const SAVED_VIEWS_BASE_URL = '/project/saved_views'
const SHARE_VIEW_URL = `${SAVED_VIEWS_BASE_URL}/share`

export class SavedViewService {
  constructor(private client: ApiClient) {}

  async getSavedViews(proj_uuid: string): Promise<SavedView[]> {
    const { data } = await this.client.get<SavedView[]>(SAVED_VIEWS_BASE_URL, {
      params: {
        proj_uuid: proj_uuid,
      },
    })

    return data
  }

  async shareViewWithUsers(
    proj_uuid: string,
    view_id: string,
    users: string[],
  ): Promise<AxiosResponse> {
    const data = await this.client.post(
      SHARE_VIEW_URL,
      {
        view_id: view_id,
        user_list: users,
      },
      {
        params: {
          proj_uuid: proj_uuid,
        },
      },
    )
    return data
  }

  async deleteSavedView(
    proj_uuid: string,
    view_uuid: string,
  ): Promise<AxiosResponse> {
    const data = await this.client.delete(
      `${SAVED_VIEWS_BASE_URL}/${view_uuid}`,
      {
        params: {
          proj_uuid: proj_uuid,
        },
      },
    )
    return data
  }

  async saveView(
    proj_uuid: string,
    view: SavedViewPayload,
  ): Promise<AxiosResponse> {
    const data = await this.client.put(
      SAVED_VIEWS_BASE_URL,
      {
        ...view,
        search_string: view.search_url,
      },
      {
        params: {
          proj_uuid: proj_uuid,
        },
      },
    )
    return data
  }

  async updateLastRecentlyUsed(
    proj_uuid: string,
    view_uuid: string,
  ): Promise<AxiosResponse> {
    const data = await this.client.patch(
      `${SAVED_VIEWS_BASE_URL}/${view_uuid}`,
      {},
      {
        params: {
          proj_uuid: proj_uuid,
        },
      },
    )
    return data
  }

  async updateSavedView(
    proj_uuid: string,
    view: Partial<SavedView> & { uuid: string },
  ): Promise<AxiosResponse> {
    const data = await this.client.patch(
      `${SAVED_VIEWS_BASE_URL}/update/${view.uuid}`,
      {
        ...view,
      },
      {
        params: {
          proj_uuid: proj_uuid,
        },
      },
    )
    return data
  }
}
